import React, { useState } from 'react';
import AsyncSelect from 'react-select/async';
import { loadAirportLocations } from '../../../api/Location';
import { LocationOption } from '../../../types/Location';
import { CustomFlight } from '../../../types/PackageBuilder';

type CustomFlightModalProps = {
  onClose: () => void;
  onSave: (flight: CustomFlight) => void;
};

const formatAirportOptionLabel = (option: LocationOption) => {
  const label = (option.label || '').trim();
  const code = (option.value || '').trim();
  if (!label && !code) return '';
  if (!label) return code;
  if (!code) return label;
  const lowerLabel = label.toLowerCase();
  const lowerCode = code.toLowerCase();
  return lowerLabel.includes(lowerCode) ? label : `${label} (${code})`;
};

const CustomFlightModal: React.FC<CustomFlightModalProps> = ({ onClose, onSave }) => {
  const [arrivalAirport, setArrivalAirport] = useState<LocationOption | null>(null);
  const [departureAirport, setDepartureAirport] = useState<LocationOption | null>(null);

  const handleSave = () => {
    if (!arrivalAirport || !departureAirport) return;
    onSave({
      airportCode: arrivalAirport.value,
      airportName: arrivalAirport.label,
      arrivalAirportCode: arrivalAirport.value,
      arrivalAirportName: arrivalAirport.label,
      departureAirportCode: departureAirport.value,
      departureAirportName: departureAirport.label,
    });
  };

  return (
    <div className="modal-backdrop">
      <div className="modal">
        <button className="close-btn" onClick={onClose} aria-label="Close">×</button>
        <div className="modal-header">
          <h2>Add Flight (Route)</h2>
        </div>
        <div className="modal-body">
          <label>
            Arrival airport
            <AsyncSelect<LocationOption, false>
              cacheOptions
              defaultOptions
              loadOptions={loadAirportLocations}
              getOptionLabel={(option) => formatAirportOptionLabel(option)}
              getOptionValue={(option) => option.value}
              onChange={(option) => setArrivalAirport(option as LocationOption)}
              value={arrivalAirport}
              placeholder="Type or select an airport"
              classNamePrefix="rs"
            />
          </label>
          <label>
            Departure airport
            <AsyncSelect<LocationOption, false>
              cacheOptions
              defaultOptions
              loadOptions={loadAirportLocations}
              getOptionLabel={(option) => formatAirportOptionLabel(option)}
              getOptionValue={(option) => option.value}
              onChange={(option) => setDepartureAirport(option as LocationOption)}
              value={departureAirport}
              placeholder="Type or select an airport"
              classNamePrefix="rs"
            />
          </label>
        </div>
        <div className="modal-actions">
          <button type="button" onClick={handleSave} disabled={!arrivalAirport || !departureAirport}>
            Add
          </button>
          <button type="button" className="secondary" onClick={onClose}>
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default CustomFlightModal;
